import { isEqual } from 'lodash'
import memoizeOne from 'memoize-one'
import { serverApi } from './serverApi'
import { SERVER_API_PERSIST_KEY } from '../reducerPersistors/constants'

type CacheEntry = {
  endpointName: string
  originalArgs: any
  data: any
}

const REHYDRATED_INDICATOR_KEY = '__rehydrated'

export function rehydrateQueryResultFromCache(arg: any, api: any) {
  const { endpointName, originalArgs } = api.getCacheEntry() as CacheEntry
  const persistedValue = rehydrationCache.pop(endpointName, originalArgs)

  if (!persistedValue || isPersistedDataEmpty(persistedValue.data)) {
    return
  }

  return api.dispatch(
    // @ts-ignore
    serverApi.util.upsertQueryData(endpointName, arg, {
      ...persistedValue.data,
      [REHYDRATED_INDICATOR_KEY]: true
    })
  )
}

const getAllPersistedQueriesFromLocalstorage = memoizeOne((): CacheEntry[] => {
  try {
    const serverApi = localStorage.getItem('persist:' + SERVER_API_PERSIST_KEY) // @ts-ignore
    return Object.values(JSON.parse(JSON.parse(serverApi).queries))
  } catch (e) {
    return []
  }
})

const rehydrationCache = (() => {
  let queriesToRehydrate = getAllPersistedQueriesFromLocalstorage()

  return {
    getEntries: () => queriesToRehydrate,
    pop: (endpointName: string, args: any): CacheEntry | undefined => {
      const cachedResult = queriesToRehydrate.find(persistedResult => {
        return (
          persistedResult.endpointName === endpointName &&
          isEqual(persistedResult.originalArgs, args)
        )
      })

      // Only rehydrate each entry once
      queriesToRehydrate = queriesToRehydrate.filter(item => item !== cachedResult)

      return cachedResult
    }
  }
})()

function isPersistedDataEmpty(persistedData: object | undefined | null): persistedData is object {
  if (!persistedData) {
    return true
  }

  return !Object.keys(persistedData)?.filter(key => key !== REHYDRATED_INDICATOR_KEY)?.length
}
